import LineItemCitation, { LineItemCitationFromJson } from './LineItemCitation'

export interface LineItemFromJson {
  amount: number
  description: string
  citation: LineItemCitationFromJson|null
}

class LineItem {
  amount: number
  description: string
  citation: LineItemCitation|null

  constructor (amount: number, description: string, citation: LineItemCitation|null) {
    this.amount = amount
    this.description = description
    this.citation = citation
  }

  static fromJson ({ amount, description, citation }: LineItemFromJson) {
    return new LineItem(amount, description, citation ? LineItemCitation.fromJson(citation) : null)
  }
}

export default LineItem
